import { render, staticRenderFns } from "./MaintenanceRequestForm.vue?vue&type=template&id=1c5b958f&scoped=true&"
import script from "./MaintenanceRequestForm.vue?vue&type=script&lang=ts&"
export * from "./MaintenanceRequestForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5b958f",
  null
  
)

export default component.exports